import React, { Component } from 'react';
import _ from 'lodash';

import { MoreVert as MoreVertIcon } from '@material-ui/icons';

import { withStyles } from '@material-ui/core/styles';
import {
	WithStyles,
	createStyles,
} from '@material-ui/core';


import { MyPATPopMenu, MenuData } from '../../../common';


const styles = createStyles({
	
	toolTipArrow: {
        '&:hover:after': {
            content: '""',
            position: 'absolute',
            left: '50%',
            marginLeft: -5,
            bottom: -8,
            width: 0,
            height: 0,
            borderLeft: '5px solid rgba(0, 0, 0, 0)',
            borderRight: '5px solid rgba(0, 0, 0, 0)',
            borderBottom: '8px solid rgb(0, 0, 0)'
        }
    }
});

//@ts-ignore
interface ContentMoreMenuProps extends WithStyles<typeof styles> {
	classes: any,
	clicked?: Function,
	mileStoneAction:[],
	attachedComponent: string
}
interface ContentMoreMenuState {
	moreAnchorEl: any
}

class ContentMoreMenu extends Component<ContentMoreMenuProps, ContentMoreMenuState>{
	menuItems: MenuData[] = [{
		type: 'callback',
		id: 2,
		to: "",
		img: "",
		text: "Delete"
	}
];

	constructor(props: ContentMoreMenuProps, state: ContentMoreMenuState) {
		super(props);

		this.clicked = this.clicked.bind(this);
	}

	clicked(item: any) { 
		if (this.props.clicked) {
			this.props.clicked(this.props.mileStoneAction);
		}
	}
	render() {
		const {classes, attachedComponent} = this.props;
		let menuI: MenuData[] = this.menuItems;
		return (<MyPATPopMenu
		className={classes.toolTipArrow} id="content-more-menu" 
		icon={MoreVertIcon}
		 menuItem={menuI}
		 clicked={this.clicked}
		 valueTooltip={attachedComponent}  />
		);
	}
}

// @ts-ignore
export default withStyles(styles)(ContentMoreMenu);